import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const ArrowLeftRightIcon: React.FC<OneColorIconProps> = ({ size = 24, color = 'white', className, onClick }) => {
  const hex = getHexColor(color)
  return (
    <svg
      className={className}
      width={size}
      height={size + 6}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <g>
        <path
          d="M23.6329 22.6758C24.0625 22.2656 24.043 21.6406 23.6329 21.2402L17.1582 14.8633C16.9629 14.668 16.6895 14.5508 16.4356 14.5508C15.8692 14.5508 15.4883 14.9414 15.4883 15.498C15.4883 15.7715 15.586 15.9863 15.7715 16.1816L18.6231 18.9551L21.0254 21.1035L18.1836 21.0059L0.957073 21.0059C0.410198 21.0059 4.16041e-05 21.3965 4.16041e-05 21.9629C4.16041e-05 22.5195 0.410198 22.9102 0.957073 22.9102L18.1836 22.9102L21.0254 22.8125L18.6231 24.9609L15.7715 27.7344C15.586 27.9297 15.4883 28.1445 15.4883 28.418C15.4883 28.9746 15.8692 29.3652 16.4356 29.3652C16.6895 29.3652 16.9629 29.248 17.1582 29.0527Z"
          fill={hex}
          fill-opacity="0.85"
        />
        <path
          d="M0.322307 6.69922C-0.117146 7.10938-0.0976146 7.73438 0.322307 8.125L6.79692 14.502C6.99223 14.6973 7.26567 14.8145 7.51957 14.8145C8.07621 14.8145 8.45707 14.4238 8.45707 13.8672C8.45707 13.5938 8.36918 13.3789 8.17387 13.1934L5.33207 10.4102L2.91996 8.26172L5.77153 8.35938L22.9883 8.35938C23.5352 8.35938 23.9454 7.96875 23.9454 7.41211C23.9454 6.85547 23.5352 6.45508 22.9883 6.45508L5.77153 6.45508L2.91996 6.55273L5.33207 4.4043L8.17387 1.63086C8.36918 1.43555 8.45707 1.2207 8.45707 0.947266C8.45707 0.400391 8.07621 0 7.51957 0C7.26567 0 6.99223 0.126953 6.79692 0.322266Z"
          fill={hex}
          fill-opacity="0.85"
        />
      </g>
    </svg>
  )
}
